import { attachmentUrl, formatBytes, isImage } from "../lib/attachments";
import { Paperclip, Download, FileText, Image as ImageIcon } from "lucide-react";

/**
 * Renders a list of attachments with image previews.
 * Auth: pass `email` for public/customer view; pass `token` for staff view.
 */
export default function AttachmentList({ attachments, email, token, testid = "attachment-list" }) {
  if (!attachments || attachments.length === 0) return null;
  return (
    <div className="space-y-2" data-testid={testid}>
      <div className="text-[10px] font-mono uppercase tracking-widest text-slate-500 flex items-center gap-1.5">
        <Paperclip className="w-3.5 h-3.5" /> Attachments ({attachments.length})
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
        {attachments.map((a) => {
          const url = attachmentUrl(a, { email, token });
          const image = isImage(a);
          return (
            <a
              key={a.id}
              href={url}
              target="_blank"
              rel="noreferrer"
              className="group bg-white border border-slate-200 rounded-lg overflow-hidden hover:border-blue-500 hover:shadow-sm transition-all"
              data-testid={`attachment-${a.id}`}
            >
              {image ? (
                <div className="aspect-video bg-slate-50 overflow-hidden grid place-items-center">
                  <img
                    src={url}
                    alt={a.filename}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
              ) : (
                <div className="aspect-video bg-slate-50 grid place-items-center">
                  <FileText className="w-8 h-8 text-slate-400" />
                </div>
              )}
              <div className="p-2 flex items-center gap-2">
                {image ? <ImageIcon className="w-3.5 h-3.5 text-slate-400 shrink-0" /> : <Paperclip className="w-3.5 h-3.5 text-slate-400 shrink-0" />}
                <div className="min-w-0 flex-1">
                  <div className="text-xs font-semibold text-slate-800 truncate">{a.filename}</div>
                  <div className="text-[10px] text-slate-500">{formatBytes(a.size)}</div>
                </div>
                <Download className="w-3.5 h-3.5 text-slate-400 group-hover:text-blue-600" />
              </div>
            </a>
          );
        })}
      </div>
    </div>
  );
}
